import { fork, all } from "redux-saga/effects";
import authorizeSagas from "AuthorizeLink/sagas";
import userSagas from "UserAuthorized/sagas/sagas";

export default function* rootSagas() {
  yield all([fork(userSagas), fork(authorizeSagas)]);
}
